<template>
  <div
    v-if="shouldBeDisplayed"
  >
    <div class=" card shadow bg-gray-200 py-2 px-3">
      <div class="card-body">
        <h5 class="card-title  mb-1">
          Voulez-vous supprimer votre compte ?
        </h5>
        <p
          v-if="!accountDeletable"
          class="card-text text-muted "
        >
          Malheureusement, vous ne pouvez pas supprimer votre compte si vous avez des contrats en cours.
          veuillez contacter le support si vous avez besoin d'aide.
        </p>
        <div v-else>
          <p class="card-text text-muted mb-2">
            La suppression de votre compte est irréversible. Toutes vos données seront définitivement supprimées.
          </p>
          <button
            type="button"
            class="btn btn-outline-danger d-flex align-items-center justify-content-center"
            @click="openDeleteModal"
          >
            <v-icon
              icon="trash"
              class="me-1 trash-icon"
            />
            Supprimer mon compte
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import activeContractsMixin from '@/mixins/activeContracts';

export default {
  name: 'AccountDeleteButton',
  mixins: [activeContractsMixin],
  props: {
    conditions: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['delete-account'],
  computed: {
    shouldBeDisplayed() {
      return true;
    },
    accountDeletable() {
      return this.coulddeleteaccount;
    },
  },
  async mounted() {
    await this.ensureContractsLoaded();
  },
  methods: {
    openDeleteModal() {
      this.$emit('delete-account');
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  border-width: 2px;
}
.btn-outline-danger:hover .trash-icon {
  filter: brightness(0) invert(1);
  transition: all 0.3s ease;
}
</style>
